function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { ADDRESS_FORM_FIELD_MAX_LENGTH } from '../../../../customer/addresses/addresses.constants';
var AddressWrapupController = /*#__PURE__*/function () {
  function AddressWrapupController() {
    _classCallCheck(this, AddressWrapupController);
    Object.assign(this, {
      CoreLocaleKeys: CoreLocaleKeys,
      countryName: '',
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      formMaxLengthValidation: ADDRESS_FORM_FIELD_MAX_LENGTH
    });
  }
  return _createClass(AddressWrapupController, [{
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.addressWrapupModel && changesObj.addressWrapupModel.currentValue !== changesObj.addressWrapupModel.previousValue || changesObj.addressCountries && changesObj.addressCountries.currentValue !== changesObj.addressCountries.previousValue) {
        this.setCountryName();
      }
    }
  }, {
    key: "onChange",
    value: function onChange() {
      this.onModelChange()(this.addressWrapupModel);
    }
  }, {
    key: "setCountryName",
    value: function setCountryName() {
      var _this = this;
      if (this.isCountryFieldReadonly && this.addressWrapupModel && this.addressCountries) {
        var selectedCountry = this.addressCountries.find(function (country) {
          return country.value === _this.addressWrapupModel.country;
        });
        this.countryName = selectedCountry ? selectedCountry.label : this.addressWrapupModel.country;
      }
    }
  }]);
}();
export default {
  bindings: {
    addressCountries: '<',
    addressStates: '<',
    addressWrapupModel: '<',
    formMaxLengthValidation: '<',
    isAutocompleteOff: '<?',
    isCountryFieldReadonly: '<?',
    isDisabled: '<?',
    isRequired: '<?',
    isShipToFieldVisible: '<?',
    onModelChange: '&',
    initialFormValues: '<?',
    postalCodeSettings: '<',
    requiredFields: '<'
  },
  template: require('./address.wrapup.form.html'),
  controller: AddressWrapupController
};